var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-btn",class:[
    'weui-btn_'+_vm.type,
    'weui-btn-size_'+_vm.size,
    {
        'weui-btn_disabled':_vm.disabled,
        'weui-btn_ghost':_vm.ghost
    }],attrs:{"href":"javascript:;"},on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }